import React from "react";
import Card from "components/card";
import { FileText } from "lucide-react";
import Button from "components/button";

const DocumentCard = ({
    title,
    date,
    type = "PDF"
}) => {
    return (
        <Card className="bg-white text-slate-900 flex flex-col gap-6 rounded-2xl border border-slate-200 hover:shadow-md transition-all cursor-pointer dark-mode-card">
            <div className="pb-6 p-4">
                <div className="flex items-start justify-between">
                    <div className="flex items-start gap-3">
                        <div className="p-2 rounded bg-emerald-100">
                            <FileText className="w-5 h-5 text-emerald-600" />
                        </div>
                        <div>
                            <p className="font-semibold text-sm title-text">{title}</p>
                            <p className="text-xs muted-text">{date}</p>
                        </div>
                    </div>
                    <span className="status-indicator normal !border-none bg-slate-50">{type}</span>
                </div>
                <Button className="access-button btn-download !h-8 !text-sm w-full mt-3">
                    Download
                </Button>
            </div>
        </Card>
    )
};
export default DocumentCard;